import React, { useState } from 'react';
import FileSaver from 'file-saver';

const xIcon = '/icons/close.svg';

const Relatorio = ({
  resultadoState,
  setRelatorio,
  metanoNM,
  biogasCalc,
  resData
}) => {
  const [cidade, setCidade] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const separator = ';';


  const formatDataPoint = (data) => {
    return `${data?.ano || ''};${data?.quantidade?.toString() || ''}`;
  };

  const prepareDataVectors = async () => {
    const metaData = resultadoState.metaData;
    const dataVet = new Array(7);
    
    try {
      dataVet[0] = resData;
      dataVet[1] = metaData.coConservador[1];
      dataVet[2] = metaData.coRecomendado[1];
      dataVet[3] = metaData.metanoConservador[1];
      dataVet[4] = metaData.metanoRecomendado[1];
      dataVet[5] = await biogasCalc(dataVet[1]);
      dataVet[6] = await metanoNM(dataVet[1]);

      // Sort all data vectors by year
      return dataVet.map(vector => 
        vector.sort((a, b) => parseFloat(a.ano) - parseFloat(b.ano))
      );
    } catch (error) {
      console.error('Error preparing data vectors:', error);
      throw error;
    }
  };

  const generateCSV = (dataVet) => {
    const headers = [
      'RSU',
      'Metano_Conservador(t)',
      'Metano_Recomendado(t)',
      'Dioxido_Conservador(t)',
      'Dioxido_Recomendado(t)',
      'Biogas(NM)',
      'Metano(NM)'
    ];

    let csvContent = headers.join(separator + separator) + '\n';
    csvContent += `Ano${separator}Quantidade${separator}`.repeat(7).slice(0, -1) + '\n';

    for (let i = 0; i < dataVet[1].length; i++) {
      const row = dataVet.map(vector => formatDataPoint(vector[i]));
      csvContent += row.join(separator) + '\n';
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    FileSaver.saveAs(blob, `${cidade ? cidade + '-' : ''}Relatorio.csv`);
  };

  const handleGenerateReport = async () => {
    try {
      setIsGenerating(true);
      const dataVet = await prepareDataVectors();
      generateCSV(dataVet);
    } catch (error) {
      console.error('Error generating report:', error);
      // You might want to show an error message to the user here
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold text-gray-800">Gerar Relatório</h2>
          <button
            onClick={setRelatorio}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <img className='w-8' src={xIcon} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          <div className="space-y-4">
            <div>
              <label htmlFor="cidade" className="block text-sm font-medium text-gray-700 mb-1">
                Município (opcional)
              </label>
              <input
                id="cidade"
                type="text"
                value={cidade}
                onChange={(e) => setCidade(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="Digite o nome do município"
              />
            </div>

            <button
              onClick={handleGenerateReport}
              disabled={isGenerating}
              className={`w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white 
                ${isGenerating ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}
                transition-colors duration-200`}
            >
              {isGenerating ? (
                <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Gerando...
                </>
              ) : (
                'Gerar Relatório CSV'
              )}
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 text-sm text-gray-500 rounded-b-lg">
          O relatório será gerado em formato CSV com todos os dados calculados.
        </div>
      </div>
    </div>
  );
};

export default Relatorio;